module.exports = __webpack_public_path__ + "static/img/partner_I.5e411cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_I.png
// module id = xVEd
// module chunks = 9